import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var __jsx = React.createElement;
import React, { useMemo, useState, useEffect } from "react";
import { useTranslation } from "@i18n";
import Loader3d from "./Loader3d";
import { useParams } from "react-router-dom";
import FinanceDetailsCard from "@/components/shared/FinanceDetailsCard/FinanceDetailsCard";
import { BottomSheet } from "@componentsShared/BottomSheet";
import InstallmentCalculatorView from "@/_MiniApps/Installment-calculator/InstallmentCalculatorView";
import useBoolean from "@hooks/useBoolean";
import InstallmentCalculatorTerms from "@/_MiniApps/Installment-calculator/InstallmentCalculatorTerms";
import { trackEvents } from "@/common/events/events";
import { getFinanceCalculatorCarCondition } from "@/_MiniApps/Installment-calculator/carHelpers";
import { calculateFinanceValues } from "@/_MiniApps/Installment-calculator/calculateFinanceValues";
import { Drawer, DrawerClose, DrawerContent, DrawerHeader } from "@/components/Drawer";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { api__getWarrantyList } from "@/apis/orders/orders";
var FinanceCarCard = function FinanceCarCard(_ref) {
  var _location2, _ref4, _recalculated$period, _postData$price, _postData$price$finan, _ref5, _recalculated$down_pa, _postData$price2, _postData$price2$fina, _ref6, _recalculated$last_pa, _postData$price3, _postData$price3$fina, _ref7, _recalculated$monthly, _postData$price4, _postData$price4$fina, _postData$details2, _postData$g4Data2, _postData$details3, _localWarrantyData$fi, _postData$details4, _postData$g4Data3, _postData$details5, _localWarrantyData$fi2, _postData$details6;
  var postData = _ref.postData,
    onPeriodChange = _ref.onPeriodChange,
    checkoutOrder = _ref.checkoutOrder,
    setCheckoutOrder = _ref.setCheckoutOrder,
    _ref$canChangeCalcula = _ref.canChangeCalculations,
    canChangeCalculations = _ref$canChangeCalcula === void 0 ? true : _ref$canChangeCalcula;
  var _useTranslation = useTranslation(["web_checkout_finance", "web_post_view"]),
    t = _useTranslation.t;
  var params = useParams();
  var _useState = useState(null),
    installmentCalculatorData = _useState[0],
    setInstallmentCalculatorData = _useState[1];
  var calculator = useBoolean();
  var _useState2 = useState(false),
    hasInteracted = _useState2[0],
    setHasInteracted = _useState2[1];
  var isMobile = useIsMobile();
  // Pending warranty data from period changes inside calculator — NOT pushed to parent until submit
  var _useState3 = useState(null),
    localWarrantyData = _useState3[0],
    setLocalWarrantyData = _useState3[1];
  useMemo(function () {
    if (!installmentCalculatorData) {
      var dataInSession = sessionStorage.getItem("installment-calculator-".concat(params.id));
      if (dataInSession) {
        var installmentCalculatorSessionData = JSON.parse(dataInSession);
        setInstallmentCalculatorData(_objectSpread({}, installmentCalculatorSessionData));
      }
    }
  }, []);
  useEffect(function () {
    var _location;
    var dataInSession = sessionStorage.getItem("installment-calculator-".concat(postData === null || postData === void 0 ? void 0 : postData.post_id));
    var urlParams = new URLSearchParams((_location = location) === null || _location === void 0 ? void 0 : _location.search);
    var encodedData = urlParams.get('finance_calculator_data');
    if (encodedData) {
      var decodedData = decodeURIComponent(encodedData);
      try {
        var parsedData = JSON.parse(decodedData);
        setInstallmentCalculatorData(parsedData);
        // Persist to sessionStorage
        sessionStorage.setItem("installment-calculator-".concat(postData === null || postData === void 0 ? void 0 : postData.post_id), JSON.stringify(parsedData));
        return;
      } catch (error) {
        console.error("Failed to parse finance_calculator_data:", error);
      }
    }
    if (dataInSession) {
      var installmentCalculatorSessionData = JSON.parse(dataInSession);
      setInstallmentCalculatorData(_objectSpread({}, installmentCalculatorSessionData));
    }
  }, [sessionStorage, postData === null || postData === void 0 ? void 0 : postData.post_id, (_location2 = location) === null || _location2 === void 0 ? void 0 : _location2.href]);
  var handleFirstInteraction = function handleFirstInteraction(_ref2) {
    var field = _ref2.field;
    if (hasInteracted) {
      console.log('field', field);
      setHasInteracted(false);
      trackEvents("finance_calculator_interact", {
        post_id: params.id,
        field_interaction: field
      });
    }
  };
  var handleCalculatorDataChange = function handleCalculatorDataChange(calculatorData) {
    setInstallmentCalculatorData(calculatorData);
    sessionStorage.setItem("installment-calculator-".concat(params.id), JSON.stringify(calculatorData));
    // On submit ("موّل سيارتك الآن"), push pending warranty data to parent checkoutOrder synchronously
    if (localWarrantyData && setCheckoutOrder) {
      setCheckoutOrder(function (prev) {
        return prev ? _objectSpread(_objectSpread({}, prev), localWarrantyData) : localWarrantyData;
      });
    }
  };

  // Internal handler: calls API on period change but stores locally — parent checkoutOrder is NOT updated
  var handleInternalPeriodChange = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(period) {
      var _checkoutOrder$financ, _checkoutOrder$financ2, _checkoutOrder$financ3;
      var currentWarrantyId, apiParams, updated;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            currentWarrantyId = checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$financ = checkoutOrder.finance_warrantyV2) === null || _checkoutOrder$financ === void 0 ? void 0 : (_checkoutOrder$financ2 = _checkoutOrder$financ.items) === null || _checkoutOrder$financ2 === void 0 ? void 0 : (_checkoutOrder$financ3 = _checkoutOrder$financ2.find(function (i) {
              return i.selected;
            })) === null || _checkoutOrder$financ3 === void 0 ? void 0 : _checkoutOrder$financ3.id;
            apiParams = {
              post_id: Number(params.id),
              installment_period: period
            };
            if (currentWarrantyId) {
              apiParams.warranty_id = currentWarrantyId;
            }
            _context.n = 1;
            return api__getWarrantyList(apiParams)["catch"](function () {
              return null;
            });
          case 1:
            updated = _context.v;
            if (updated) setLocalWarrantyData(updated);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleInternalPeriodChange(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (calculator.value) {
      setHasInteracted(true);
    } else {
      setHasInteracted(false);
      // Reset pending warranty data when calculator is dismissed without submitting
      setLocalWarrantyData(null);
    }
  }, [calculator.value]);
  var handleCalculatorClick = function handleCalculatorClick() {
    calculator.setTrue();
    trackEvents("finance_calculator_open", {
      post_id: params.id
    });
  };

  // Recalculate finance values using the same formula as InstallmentCalculatorView
  // This ensures monthly_installment updates when warranty changes (via checkoutOrder.finance_calculator_data)
  var recalculated = useMemo(function () {
    var _postData$g4Data, _postData$details, _installmentCalculato, _installmentCalculato2;
    var cashPrice = postData === null || postData === void 0 ? void 0 : (_postData$g4Data = postData.g4Data) === null || _postData$g4Data === void 0 ? void 0 : _postData$g4Data.post_price;
    if (!cashPrice) return null;
    var carCondition = getFinanceCalculatorCarCondition(postData);
    var isPreowned = postData === null || postData === void 0 ? void 0 : (_postData$details = postData.details) === null || _postData$details === void 0 ? void 0 : _postData$details.is_preowned;
    return calculateFinanceValues(carCondition, cashPrice, isPreowned, installmentCalculatorData ? {
      period: installmentCalculatorData.period,
      down_payment: installmentCalculatorData.down_payment,
      last_payment: installmentCalculatorData.last_payment,
      max_down_payment_percent: (_installmentCalculato = installmentCalculatorData.max_down_payment_percent) !== null && _installmentCalculato !== void 0 ? _installmentCalculato : 0.5,
      max_last_payment_percent: (_installmentCalculato2 = installmentCalculatorData.max_last_payment_percent) !== null && _installmentCalculato2 !== void 0 ? _installmentCalculato2 : 0.45
    } : null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.finance_calculator_data);
  }, [postData, installmentCalculatorData, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.finance_calculator_data]);
  var installmentPeriod = (_ref4 = (_recalculated$period = recalculated === null || recalculated === void 0 ? void 0 : recalculated.period) !== null && _recalculated$period !== void 0 ? _recalculated$period : installmentCalculatorData === null || installmentCalculatorData === void 0 ? void 0 : installmentCalculatorData.period) !== null && _ref4 !== void 0 ? _ref4 : postData === null || postData === void 0 ? void 0 : (_postData$price = postData.price) === null || _postData$price === void 0 ? void 0 : (_postData$price$finan = _postData$price.finance_price) === null || _postData$price$finan === void 0 ? void 0 : _postData$price$finan.installment_period;
  var down_payment = (_ref5 = (_recalculated$down_pa = recalculated === null || recalculated === void 0 ? void 0 : recalculated.down_payment) !== null && _recalculated$down_pa !== void 0 ? _recalculated$down_pa : installmentCalculatorData === null || installmentCalculatorData === void 0 ? void 0 : installmentCalculatorData.down_payment) !== null && _ref5 !== void 0 ? _ref5 : postData === null || postData === void 0 ? void 0 : (_postData$price2 = postData.price) === null || _postData$price2 === void 0 ? void 0 : (_postData$price2$fina = _postData$price2.finance_price) === null || _postData$price2$fina === void 0 ? void 0 : _postData$price2$fina.first_payment;
  var last_payment = (_ref6 = (_recalculated$last_pa = recalculated === null || recalculated === void 0 ? void 0 : recalculated.last_payment) !== null && _recalculated$last_pa !== void 0 ? _recalculated$last_pa : installmentCalculatorData === null || installmentCalculatorData === void 0 ? void 0 : installmentCalculatorData.last_payment) !== null && _ref6 !== void 0 ? _ref6 : postData === null || postData === void 0 ? void 0 : (_postData$price3 = postData.price) === null || _postData$price3 === void 0 ? void 0 : (_postData$price3$fina = _postData$price3.finance_price) === null || _postData$price3$fina === void 0 ? void 0 : _postData$price3$fina.last_payment;
  var monthly_installment = (_ref7 = (_recalculated$monthly = recalculated === null || recalculated === void 0 ? void 0 : recalculated.monthly_installment) !== null && _recalculated$monthly !== void 0 ? _recalculated$monthly : installmentCalculatorData === null || installmentCalculatorData === void 0 ? void 0 : installmentCalculatorData.monthly_installment) !== null && _ref7 !== void 0 ? _ref7 : postData === null || postData === void 0 ? void 0 : (_postData$price4 = postData.price) === null || _postData$price4 === void 0 ? void 0 : (_postData$price4$fina = _postData$price4.finance_price) === null || _postData$price4$fina === void 0 ? void 0 : _postData$price4$fina.text;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !postData && /*#__PURE__*/React.createElement(Loader3d, null), postData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FinanceDetailsCard, {
    title: (postData === null || postData === void 0 ? void 0 : (_postData$details2 = postData.details) === null || _postData$details2 === void 0 ? void 0 : _postData$details2.h1) || '',
    installmentPeriod: installmentPeriod || 0,
    down_payment: down_payment || 0,
    last_payment: last_payment || 0,
    monthly_installment: monthly_installment || 0,
    showEditIcon: canChangeCalculations,
    onEditClick: handleCalculatorClick,
    showSubtitle: true
  }), /*#__PURE__*/React.createElement(Conditional, {
    condition: !isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(BottomSheet, {
    open: calculator.value,
    onOpen: calculator.setTrue,
    onClose: calculator.setFalse,
    maxHeight: "95%",
    maxHeightDesktop: "95%",
    hideTitleBar: true,
    screens: [{
      title: t('calculate_financing_2', {
        ns: 'web_post_view'
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorView, {
        carCondition: getFinanceCalculatorCarCondition(postData),
        cashPrice: (postData === null || postData === void 0 ? void 0 : (_postData$g4Data2 = postData.g4Data) === null || _postData$g4Data2 === void 0 ? void 0 : _postData$g4Data2.post_price) || 100000,
        onClose: calculator.setFalse,
        onInteraction: handleFirstInteraction,
        isPreowned: postData === null || postData === void 0 ? void 0 : (_postData$details3 = postData.details) === null || _postData$details3 === void 0 ? void 0 : _postData$details3.is_preowned,
        postId: postData === null || postData === void 0 ? void 0 : postData.post_id,
        onDataChange: handleCalculatorDataChange,
        initialValues: installmentCalculatorData,
        dynamicFinanceCalculatorData: (_localWarrantyData$fi = localWarrantyData === null || localWarrantyData === void 0 ? void 0 : localWarrantyData.finance_calculator_data) !== null && _localWarrantyData$fi !== void 0 ? _localWarrantyData$fi : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.finance_calculator_data,
        onPeriodChange: handleInternalPeriodChange,
        isEligibleForArib: postData === null || postData === void 0 ? void 0 : (_postData$details4 = postData.details) === null || _postData$details4 === void 0 ? void 0 : _postData$details4.is_eligible_for_arib
      })
    }, {
      title: t('financing_conditions', {
        ns: "web_post_view"
      }),
      component: /*#__PURE__*/React.createElement(InstallmentCalculatorTerms, null)
    }]
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-white"
  }, /*#__PURE__*/React.createElement(Drawer, {
    open: calculator.value,
    onOpenChange: calculator.toggle,
    repositionInputs: false,
    preventScrollRestoration: true
  }, /*#__PURE__*/React.createElement(DrawerContent, {
    className: "max-h-[110vh] z-[9999999]"
  }, /*#__PURE__*/React.createElement(DrawerHeader, {
    className: "bg-white p-0 rounded-t-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-3 py-4"
  }, /*#__PURE__*/React.createElement(DrawerClose, {
    asChild: true
  }, /*#__PURE__*/React.createElement("button", {
    className: "p-0 rounded-full bg-transparent outline-none border-none w-6 h-6"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    className: "text-gray-text",
    height: 6,
    width: 6
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-text font-bold w-full text-center"
  }, t('calculate_financing_2', {
    ns: 'web_post_view'
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-6 h-6"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto flex-1 max-h-fit bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-right space-y-4 text-[#333333]"
  }, /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '20px',
        textAlign: 'center'
      }
    }, "Loading Calculator...")
  }, /*#__PURE__*/React.createElement(InstallmentCalculatorView, {
    carCondition: getFinanceCalculatorCarCondition(postData),
    cashPrice: (postData === null || postData === void 0 ? void 0 : (_postData$g4Data3 = postData.g4Data) === null || _postData$g4Data3 === void 0 ? void 0 : _postData$g4Data3.post_price) || 100000,
    onClose: calculator.setFalse,
    onInteraction: handleFirstInteraction,
    onDataChange: handleCalculatorDataChange,
    postId: postData === null || postData === void 0 ? void 0 : postData.post_id,
    initialValues: installmentCalculatorData,
    isPreowned: postData === null || postData === void 0 ? void 0 : (_postData$details5 = postData.details) === null || _postData$details5 === void 0 ? void 0 : _postData$details5.is_preowned,
    dynamicFinanceCalculatorData: (_localWarrantyData$fi2 = localWarrantyData === null || localWarrantyData === void 0 ? void 0 : localWarrantyData.finance_calculator_data) !== null && _localWarrantyData$fi2 !== void 0 ? _localWarrantyData$fi2 : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.finance_calculator_data,
    onPeriodChange: handleInternalPeriodChange,
    isEligibleForArib: postData === null || postData === void 0 ? void 0 : (_postData$details6 = postData.details) === null || _postData$details6 === void 0 ? void 0 : _postData$details6.is_eligible_for_arib
  }))))))))))));
};
export default FinanceCarCard;